import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import BaySpinner from '../../BaySpinner';

interface DeleteEntryModalProps {
	t: (key: string) => string;
	onSubmitFunc: () => void;
	showDeleteEntryModal: boolean;
	setShowDeleteEntryModal: (value: boolean) => void;
	title: string;
	bodyText: string;
	submitButtonTitle?: string;
	submitButtonVariant?: string;
	isLoading?: boolean;
}

const DeleteEntryModal: React.FC<DeleteEntryModalProps> = ({
	t,
	onSubmitFunc,
	showDeleteEntryModal,
	setShowDeleteEntryModal,
	title,
	bodyText,
	submitButtonTitle = 'Delete',
	submitButtonVariant = 'danger',
	isLoading = false,
}) => {
	const handleOnClick = () => {
		onSubmitFunc();
		setShowDeleteEntryModal(false);
	};

	return (
		<Modal
			className="fs-confirm-modal"
			id="files_confirmation_modal"
			show={showDeleteEntryModal}
			onHide={() => setShowDeleteEntryModal(false)}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body className={`${isLoading ? 'bay-placeholder-overlay' : ''}`}>
				{bodyText}
			</Modal.Body>
			<Modal.Footer className="px-3 px-sm-5">
				<Row className="w-100 justify-between">
					<Col className="ps-0">
						<Button
							id="files_confirmation_modal-cancel_btn"
							variant="outline-secondary"
							onClick={() => setShowDeleteEntryModal(false)}
						>
							{t('cancel')}
						</Button>
					</Col>
					<Col className="pe-0" style={{ textAlign: 'right' }}>
						{isLoading ? (
							<Button variant={submitButtonVariant}>
								<BaySpinner
									textColor="text-white"
									title="Deleting ..."
									variant="light"
								/>
							</Button>
						) : (
							<Button
								id="files_confirmation_modal-submit_btn"
								variant={submitButtonVariant}
								onClick={handleOnClick}
							>
								{submitButtonTitle}
							</Button>
						)}
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>
	);
};

export default DeleteEntryModal;
